import React from "react";

import { EnergyModes } from "./components/energy-modes";
import { FlexibleLoadManagement } from "./components/flexible-load-management";
import { OnTheGrid } from "./components/on-the-grid";
import { OffTheGrid } from "./components/off-the-grid";
import { HowItWorks as HowItWorksHero } from "./components/how-it-works";
import { PowerMove } from "./components/power-move";

const howItWorksPageElement = (
  <div>
    <FlexibleLoadManagement />
    <OnTheGrid />
    <OffTheGrid />
    <HowItWorksHero />
    <EnergyModes />
    <PowerMove />
  </div>
);

export function HowItWorks() {
  return howItWorksPageElement;
}
